import { gql } from '@apollo/client';

export const orderDetailGql = gql`
  query OrderDetail($purchaseOrderId: ID!, $productId: ID!, $deliveryDate: String, $branchId: ID!) {
    OrderDetail(
      purchaseOrderId: $purchaseOrderId
      productId: $productId
      deliveryDate: $deliveryDate
      branchId: $branchId
    ) {
      purchaseOrderId
      productName
      productId
      numericCode
      colorAbbreviation
      alphaId
      statusDescription
      personId
      personalName
      otifValue
      monetaryDiscountNoShow
      monetaryDiscountScheduleChange
    }
  }
`;
